// components/Header.jsx
import React from "react";
import "./index.css";
const Header = () => {
  const navItems = [
    { id: "about", label: "About Us" },
    { id: "focus", label: "Our Focus" },
    { id: "theme", label: "Our Theme" },
    { id: "past-highlights", label: "Past Highlights" },
    { id: "objective", label: "Our Objective" },
    { id: "testimonials", label: "Testimonials" },
    { id: "contact", label: "Contact Us" },
  ];

  return (
    <div className="app-header">
      <div className="header-flex">
        {/* 顶部名言展示 */}
        <div className="header-quote">
          <p>Summer International</p>
        </div>

        {/* 主导航栏 */}
        <nav className="header-nav">
          <div className="nav-menu">
            {navItems.map((item) => (
              <div
                key={item.id}
                className="nav-item"
                onClick={() => {
                  const section = document.getElementById(
                    `background-${item.id}`
                  );
                  if (section) {
                    section.scrollIntoView({ behavior: "smooth" });
                  }
                }}
              >
                {item.label}
              </div>
            ))}
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
